module.exports = __webpack_public_path__ + "img/download-video.cb584147.svg";